import * as React from "react";

interface FlightCtaIconProps {
  className?: string;
}

export const FlightCtaIcon: React.FC<FlightCtaIconProps> = ({ className }) => (
  <svg 
    width="17" 
    height="17" 
    viewBox="0 0 17 17" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path 
      d="M7.19848 7.04425L0.871484 4.3345C0.535651 4.18967 0.333151 3.94517 0.263984 3.601C0.194651 3.25667 0.289484 2.955 0.548484 2.696L0.871484 2.3635C0.985651 2.24933 1.1209 2.16692 1.27723 2.11625C1.43373 2.06558 1.59598 2.05375 1.76398 2.08075L10.6197 3.63275L13.7387 0.498001C14.0709 0.166001 14.4761 0 14.9542 0C15.4324 0 15.8375 0.166001 16.1695 0.498001C16.5017 0.830001 16.6677 1.23517 16.6677 1.7135C16.6677 2.19167 16.5017 2.59675 16.1695 2.92875L13.0502 6.06325L14.587 14.9038C14.6138 15.0718 14.6045 15.2365 14.559 15.398C14.5135 15.5595 14.4337 15.6973 14.3195 15.8115L13.987 16.119C13.728 16.378 13.4238 16.4755 13.0745 16.4115C12.7252 16.3473 12.478 16.1473 12.333 15.8115L9.63873 9.47475L6.82923 12.269L7.36948 15.3788C7.39648 15.5134 7.3914 15.6438 7.35423 15.77C7.31707 15.8963 7.24973 16.0083 7.15223 16.1058L6.80423 16.444C6.6094 16.639 6.3764 16.7147 6.10523 16.671C5.83407 16.6275 5.63115 16.4846 5.49648 16.2423L3.72923 12.9538L0.440734 11.1865C0.198401 11.0518 0.0554839 10.8489 0.0119839 10.5778C-0.0316827 10.3066 0.043984 10.0736 0.238984 9.87875L0.577234 9.53075C0.674734 9.43325 0.786651 9.36433 0.912984 9.324C1.03915 9.28367 1.16957 9.27692 1.30423 9.30375L4.39848 9.8385L7.19848 7.04425Z" 
      fill="currentColor"
    />
  </svg>
);